import { Compass } from "lucide-react";
import { useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { usePageTitle } from "@/hooks/use-page-title";

export function NotFoundPage() {
  usePageTitle("Not Found");
  const location = useLocation();
  const headingRef = useRef<HTMLHeadingElement>(null);

  // Move focus to the heading so screen readers announce the 404. Client-side
  // route changes don't reset focus the way a full page load does.
  useEffect(() => {
    headingRef.current?.focus();
  }, []);

  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-6 text-center">
      {/* Branded hero block — mirrors the login page's primary icon tile */}
      <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary shadow-lg">
        <Compass className="h-7 w-7 text-primary-foreground" />
      </div>
      <p className="font-mono text-[13px] font-medium uppercase tracking-[0.25em] text-primary">
        404
      </p>
      <h1
        ref={headingRef}
        tabIndex={-1}
        className="mt-2 text-2xl font-bold tracking-tight text-foreground outline-none"
      >
        Page not found
      </h1>
      <p className="mt-1.5 max-w-md text-[15px] text-muted-foreground">
        No route matches{" "}
        <code className="rounded bg-muted px-1.5 py-0.5 font-mono text-[13px] text-foreground">
          {location.pathname}
        </code>
      </p>
      <Link to="/" className="mt-6">
        <Button variant="outline" size="sm">
          Back to machines
        </Button>
      </Link>
    </div>
  );
}
